import { FlaskConical, Leaf, PackageCheck, Pill, Sparkles } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

const ICONS = { apis: Pill, actives: Sparkles, nutra: Leaf, rare: FlaskConical, fdf: PackageCheck };

// Two-column category grid separated by hairlines; an odd last card spans the full row.
export const CategoryGrid = ({ categories = [] }) => (
  <div className="grid overflow-hidden border border-line bg-surface sm:grid-cols-2" data-testid="category-grid">
    {categories.map((c, i) => {
      const Icon = ICONS[c.id] || Pill;
      return (
        <Reveal
          key={c.id}
          delay={i * 0.08}
          className={`group relative bg-surface p-8 transition-colors duration-500 hover:bg-accent-soft sm:p-10 lg:p-14 ${i ? "border-t border-line" : ""} ${i === 1 ? "sm:border-t-0" : ""} ${i % 2 ? "sm:border-l" : ""} ${i === categories.length - 1 && i % 2 === 0 ? "sm:col-span-2" : ""}`}
          data-testid={`category-${c.id}`}
        >
          <div className="flex items-start justify-between">
            <Icon className="h-7 w-7 text-accent transition-transform duration-500 group-hover:-rotate-12" strokeWidth={1.4} />
            <span className="font-mono text-[12px] uppercase tracking-[0.2em] text-muted">{c.tag}</span>
          </div>
          <h3 className="mt-12 font-display text-2xl font-semibold tracking-[-0.03em] text-ink sm:text-3xl">{c.title}</h3>
          <p className="mt-4 max-w-md text-[15px] leading-relaxed text-muted">{c.body}</p>
        </Reveal>
      );
    })}
  </div>
);
